const isContainerReefer = (containerType?: string) =>
  containerType === 'ReeferEutectic' ||
  containerType === 'ReeferHeated' ||
  containerType === 'ReeferInsulated' ||
  containerType === 'ReeferIntegratedMachinery' ||
  containerType === 'ReeferRefrigerated' ||
  containerType === 'ReeferRefrigeratedAndHeated' ||
  containerType === 'ReeferRefrigeratedOrHeatedWithIntegratedEquipment' ||
  containerType === 'ReeferSelfPowered'

/**
 * Parses the container length to the base length.
 *
 * @param containerLength - The container length to parse.
 * @returns The base container length: 20 or 40.
 *          For example, for 38, 40, 45, returns 40.
 *          For 18, 20, 22 returns 20.
 */
const getBaseContainerLength = (containerLength: number) => {
  return containerLength < 30 ? 20 : 40
}

export { getBaseContainerLength, isContainerReefer }
